import { DateTime, Settings } from 'luxon';

const currentDate = DateTime.now();

Settings.defaultZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

// Month range: 6 months
export const monthsRange = {
  maxDate: currentDate.toISODate() as string,
  minDate: currentDate.minus({ months: 6 }).toISODate() as string,
};

export const eighteenthMonthsRange = {
  maxDate: currentDate.toISODate() as string,
  minDate: currentDate.minus({ months: 18 }).toISODate() as string,
};

export const lastThirtyDays = {
  maxDate: currentDate.toISODate() as string,
  minDate: currentDate.minus({ days: 30 }).toISODate() as string,
};

// 3 Months Range
export const threeMonthsRange = {
  maxDate: currentDate.toISODate() as string,
  minDate: currentDate.minus({ months: 3 }).toISODate() as string,
};

// Today
export const today = {
  maxDay: currentDate,
  minDay: currentDate,
};

// Day range: Last 7 days
export const daysRange = {
  maxDay: currentDate,
  minDay: currentDate.minus({ days: 6 }),
};

// Date range: 6 months
export const datesRangeMsg =
  "Common.datesRangeMsg";

// Date range: 31 days
export const thirtyDaysDateRangeMsg =
  "Common.oneMonthDateRangeMsg";

export const eighteenthMonthsDateRangeMsg =
  "Common.eighteenthMonthsDateRangeMsg";

// State Mileage reports: 60 months range (align with CANJS daterangepicker)
export const stateMileageDateRange = {
  maxDate: currentDate.toISODate() as string,
  minDate: currentDate.minus({ months: 60 }).toISODate() as string,
};

// Default date range for Mileage by State & Driver/Vehicle Segment: last 30 days
export const last30DaysRange = {
  minDay: currentDate.minus({ days: 30 }),
  maxDay: currentDate,
};

export const stateMileageDateRangeMsg =
  "Common.fiveYearsDateRangeMsg";

/** Filename-safe, user-readable local timestamp, e.g. `2026-09-04_04-56-30_PM`. */
export const getFormattedTimestamp = () => {
  return DateTime.local().toFormat('yyyy-MM-dd_hh-mm-ss_a');
};
